// var Host_Ip = "";  //测试
var Host_Ip = "https://jnipark.cn:10002";  //测试
// var Host_Ip = "https://47.100.188.66:10002/"; //测试

// var Host_Ip2 = "http://192.168.1.251:6030";  
const Host_Ip2 = '/api'

export { Host_Ip, Host_Ip2 }